module.exports = __webpack_public_path__ + "media/images/countrysquared/hu-c5249e93e46f93e5237d788d4db2129a.svg";